import { __ } from "@wordpress/i18n";
import {
	useBlockProps,
	useInnerBlocksProps,
	BlockControls,
} from "@wordpress/block-editor";
import { useState, useEffect, useRef } from "@wordpress/element";
import { v4 as uuidv4 } from "uuid";
import SingleBlockTypeAppender from "../utils/appender";
import Controls from "./controls";

export default function Edit(props) {
	const { attributes, setAttributes, clientId } = props;
	// count
	const [slideList, setSlideList] = useState(1);

	// ref for slider div
	const sliderRef = useRef(null);

	if (!attributes.carouselID) {
		const carouselID = "wpopus-advanced-slider-" + uuidv4();
		setAttributes({ carouselID });
	}

	const ALLOWED_BLOCKS = ["wpopus/advanced-slider-item"];
	const TEMPLATE = [["wpopus/advanced-slider-item"]];
	const blocksProps = useBlockProps();
	const { children, ...innerBlocksProps } = useInnerBlocksProps(blocksProps, {
		allowedBlocks: ALLOWED_BLOCKS,
		template: TEMPLATE,
		orientation: "horizontal",
	});

	useEffect(() => {
		wp.domReady(() => {
			const blockElement = document.querySelector(
				`[block-id="${attributes.carouselID}"]`,
			);
			if (blockElement) {
				const slideElement = blockElement.querySelectorAll("swiper-slide");

				// Access shadow DOM
				const shadow =
					blockElement.querySelector("swiper-container").shadowRoot;
				if (shadow) {
					if (attributes.options.pagination) {
						if ("bullets" == attributes.options.paginationType) {
							const paginationDots = shadow.querySelectorAll(
								".swiper-pagination-bullet",
							);
							if (paginationDots) {
								// Loop through each bullet
								Array.from(paginationDots).forEach((dot) => {
									dot.style.height = attributes.options.paginationSize.top;
									dot.style.width = attributes.options.paginationSize.left;
									dot.style.borderRadius =
										attributes.options.paginationSize.top;
									dot.style.border = `${attributes.options.paginationBorder.width} ${attributes.options.paginationBorder.style} ${attributes.options.paginationBorder.color}`;
								});
							}
						} else if ("fraction" == attributes.options.paginationType) {
							const paginationFraction = shadow.querySelector(
								".swiper-pagination-fraction",
							);
							if (paginationFraction && "undefined" != paginationFraction) {
								paginationFraction.style.color =
									attributes.options.paginationColor;
								paginationFraction.style.fontSize =
									attributes.options.paginationFractionSize;
								paginationFraction.style.fontWeight =
									attributes.options.paginationFractionWeight;
							}
						}
					}
				}

				if (
					slideElement &&
					sliderRef.current &&
					slideElement.length != slideList
				) {
					sliderRef.current.swiper.update();
					setSlideList(slideElement.length);
				}
			}
		});
	}, [innerBlocksProps]);

	return (
		<div {...innerBlocksProps}>
			<Controls attributes={attributes} setAttributes={setAttributes} />

			<div
				block-id={attributes.carouselID}
				className={`wpopus-advanced-carousel-wrapper navigation-default ${attributes.options.paginationLocation}`}
			>
				<swiper-container
					ref={sliderRef}
					rewind={true}
					speed={attributes.options.speed}
					slides-per-view={1}
					{...(attributes.options.pagination && {
						pagination: true,
						"pagination-dynamic-bullets":
							attributes.options.paginationType === "bullets",
						"pagination-clickable":
							attributes.options.paginationType === "bullets",
						"pagination-type": attributes.options.paginationType,
					})}
					navigation={attributes.options.navigation ? true : false}
					style={{
						"--swiper-navigation-color": `${attributes.options.navigationColor}`,
						"--swiper-pagination-color": `${attributes.options.paginationColor}`,
						"--wpopus-carousel-navigation-bg-color": `${attributes.options.navigationBgColor}`,
						"--wpopus-carousel-navigation-height": `${attributes.options.navigationSize.top}`,
						"--wpopus-carousel-navigation-width": `${attributes.options.navigationSize.left}`,
						"--wpopus-carousel-navigation-padding": `${attributes.options.navigationPadding.top} ${attributes.options.navigationPadding.right} ${attributes.options.navigationPadding.bottom} ${attributes.options.navigationPadding.left}`,
						"--wpopus-carousel-navigation-border": `${attributes.options.navigationBorder.width} ${attributes.options.navigationBorder.style} ${attributes.options.navigationBorder.color}`,
						"--wpopus-carousel-navigation-border-radius": `${attributes.options.navigationBorderRadius}`,
					}}
				>
					{children}
				</swiper-container>
			</div>

			<BlockControls>
				<SingleBlockTypeAppender
					isPrimary
					buttonText={__("Add Slide", "wpopus")}
					allowedBlock="wpopus/advanced-slider-item"
					clientId={clientId}
				/>
			</BlockControls>
		</div>
	);
}
